import { useState } from "react";
import "@/App.css";
import { LanguageProvider } from "@/LanguageContext";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import ProblemSection from "@/components/ProblemSection";
import ServicesSection from "@/components/ServicesSection";
import MethodSection from "@/components/MethodSection";
import ValuesSection from "@/components/ValuesSection";
import AboutSection from "@/components/AboutSection";
import MomentsSection from "@/components/MomentsSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import LegalPage from "@/components/LegalPage";
import PrivacyPage from "@/components/PrivacyPage";

function App() {
  const [page, setPage] = useState("home");

  const goTo = (p) => {
    setPage(p);
    window.scrollTo({ top: 0 });
  };

  return (
    <LanguageProvider>
      <div className="App" data-testid="app-root">
        <Header onLogoClick={() => goTo("home")} />

        {page === "home" && (
          <main>
            <HeroSection />
            <ProblemSection />
            <ServicesSection />
            <MethodSection />
            <ValuesSection />
            <AboutSection />
            <MomentsSection />
            <TestimonialsSection />
            <ContactSection />
          </main>
        )}

        {page === "legal" && <LegalPage onBack={() => goTo("home")} />}
        {page === "privacy" && <PrivacyPage onBack={() => goTo("home")} />}

        <Footer onNavigate={goTo} />
        <WhatsAppButton />
      </div>
    </LanguageProvider>
  );
}

export default App;
